module.exports = __webpack_public_path__ + "static/media/machine.6c279252.svg";